import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const accountPlusIcon: SvgIconData = {
  viewBox: '13.1 5 73.7 90',
  element: (
    <g>
      <path
        d="M66 45.7H43c-7 0-13.4 3.6-17.1 9-.7 1 .2 2.4 1.3 2.2a21 21 0 0 1 23.7 27c-.3.9.4 1.8 1.3 1.8H81a6 6 0 0 0 5.9-5.9V66.6c0-11.6-9.4-20.9-20.9-20.9"
        strokeWidth={0}
      />
      <circle cx="54.5" cy="23.1" r="18.1" strokeWidth={0} />
      <path
        d="M30 61.2q-2.7 0-5.2.8a16.9 16.9 0 1 0 5.2-.8m5.4 20h-2.3v2.3q0 .6-.2 1a3 3 0 0 1-6-1V81h-2.2l-1.4-.3a3 3 0 0 1 1.4-5.8H27v-2.3a3 3 0 0 1 6.1 0V75h2.3a3 3 0 0 1 0 6.1"
        strokeWidth={0}
      />
    </g>
  ),
};
